<template>
  <div class="h-10">
    <VField :name="name" class="h-fit" v-slot="{ meta, field }">
      <Listbox as="div" v-bind="field" v-model="selected" :defaultValue="field.value" v-slot="{ open }">
        <div class="relative">
          <ListboxButton
            class="base-selectinput"
            :class="!meta.valid && meta.touched ? 'bg-secondary/20' : ' bg-white' + customClass"
          >
            <span class="flex items-center">
              <span class="block">
                {{
                  options.find((option) => option.value == selected || option.value == field.value)?.text ||
                  (label ? "" : placeholder)
                }}
              </span>
            </span>
            <span class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
              <NuxtImg
                loading="lazy"
                src="/icons/ctrl-down.svg"
                class="h-3 w-3"
                alt="down arrow icon"
                width="24"
                height="12"
              />
            </span>
          </ListboxButton>

          <label
            v-if="label"
            class="select-none absolute left-3 z-[11] pointer-events-none transition-all"
            :class="
              isLabelFloating(open, field.value)
                ? 'text-xs -top-5 text-secondary font-semibold'
                : 'text-sm font-normal text-gray-400 top-[10px]'
            "
          >
            <span v-html="label"></span>
          </label>

          <transition
            leave-active-class="transition ease-in duration-100"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <ListboxOptions
              class="absolute z-30 max-h-56 w-full overflow-auto bg-white text-base border border-secondary focus:outline-none sm:text-sm"
            >
              <ListboxOption
                @click="onClicked"
                as="template"
                v-for="(option, index) in options"
                :value="option.value"
                :key="index"
                v-slot="{ active, selected }"
              >
                <li
                  :class="[
                    active ? 'bg-secondary text-white' : 'text-space-cadet',
                    'relative cursor-default select-none py-2 px-4',
                  ]"
                >
                  <div class="flex items-center" v-if="type == 'regionList'">
                    <span class="flex w-full" :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']">
                      {{ option.text }}
                      <div class="ml-auto">+ {{ currencyPrefix }} {{ option.price }}</div>
                    </span>
                  </div>
                  <div class="flex items-center" v-else>
                    <span :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']">
                      {{ option.text }}
                    </span>
                  </div>
                </li>
              </ListboxOption>
            </ListboxOptions>
          </transition>
        </div>
      </Listbox>
      <VErrorMessage :name="name" as="div" class="mt-1 text-xs text-red-500 px-2" />
    </VField>
  </div>
</template>

<script setup>
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/vue";

const props = defineProps({
  modelValue: String,
  options: Array,
  name: String,
  type: String,
  placeholder: String,
  label: {
    type: String,
    default: "",
  },
  customClass: {
    type: String,
    default: null,
  },
});
const currencyPrefix = useGlobalStore().siteCurrencySymbol;
const selected = ref();
const emit = defineEmits(["onSelected"]);

function isLabelFloating(open, fieldValue) {
  return open || (selected.value != null && selected.value !== "") || (fieldValue != null && fieldValue !== "");
}

function onClicked() {
  emit("onSelected", selected.value);
}
</script>
